import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import axiosInstance from '../api/axiosConfig';
import Modal from 'react-modal';
import './ManagementPages.css';

Modal.setAppElement('#root');

function ClientManagementPage() {
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSearching, setIsSearching] = useState(false);
  const searchTimeoutRef = React.useRef(null);

  // États pour la création
  const [newClient, setNewClient] = useState({
    nom_client: '',
    contact: '',
    typologie: '',
    localisation: '',
    zone: '',
    sous_zone: '',
    commercial_id: '',
    chef_zone_id: '',  // Pour GMS (Superviseur assigné)
    merchandiser_id: '',
    lieu_dit: '',
    est_gms: false,
    type_client: 'DIRECT',  // DIRECT, INDIRECT ou A_PROSPECTER
    client_direct_nom: '',  // Nom du client direct si indirect
    latitude: '',
    longitude: ''
  });

  // États pour la modification
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingClient, setEditingClient] = useState(null);

  // État pour la recherche
  const [searchTerm, setSearchTerm] = useState('');

  // États pour les filtres
  const [filterBase, setFilterBase] = useState('');
  const [filterZone, setFilterZone] = useState('');
  const [filterMerchandiser, setFilterMerchandiser] = useState('');

  // États pour les listes déroulantes
  const [zones, setZones] = useState([]);
  const [chefsZone, setChefsZone] = useState([]);
  const [superviseursGMS, setSuperviseursGMS] = useState([]);  // Liste des superviseurs GMS
  const [commerciaux, setCommerciaux] = useState([]);
  const [merchandisers, setMerchandisers] = useState([]);
  const [selectedChefZone, setSelectedChefZone] = useState(null);

  const fetchData = useCallback(async (query = '', zoneFilter = '', isSearch = false) => {
    try {
      if (!isSearch) setIsLoading(true);
      else setIsSearching(true);
      const params = new URLSearchParams();
      if (query) params.set('query', query);
      if (zoneFilter) params.set('zone', zoneFilter);
      const response = await axiosInstance.get(`/admin/clients/search?${params.toString()}`);
      setClients(response.data);
    } catch (error) { console.error("Erreur de chargement:", error); }
    finally {
      if (!isSearch) setIsLoading(false);
      else setIsSearching(false);
    }
  }, []);

  const fetchZonesAndChefs = useCallback(async () => {
    try {
      // Charger chaque donnée séparément pour éviter qu'un échec bloque tout
      const zonesRes = await axiosInstance.get('/zones/').catch(() => ({ data: [] }));
      const chefsRes = await axiosInstance.get('/chefs-zone/').catch(() => ({ data: [] }));
      const commerciauxRes = await axiosInstance.get('/admin/commerciaux/').catch(() => ({ data: [] }));
      const merchandisersRes = await axiosInstance.get('/admin/merchandisers/').catch(() => ({ data: [] }));

      // Filtrer les superviseurs GMS (est_superviseur=True)
      const superviseursGMS = chefsRes.data.filter(chef => chef.est_superviseur === true) || [];

      console.log('✅ Zones:', zonesRes.data.length);
      console.log('✅ ChefsZone:', chefsRes.data.length);
      console.log('✅ Commerciaux:', commerciauxRes.data);
      console.log('✅ Merchandisers:', merchandisersRes.data?.length);
      console.log('✅ Superviseurs GMS:', superviseursGMS.length);

      setZones(zonesRes.data);
      setChefsZone(chefsRes.data);
      setCommerciaux(commerciauxRes.data);
      setMerchandisers(merchandisersRes.data || []);
      setSuperviseursGMS(superviseursGMS);
    } catch (error) {
      console.error("Erreur chargement zones/chefs/commerciaux/merchandisers:", error);
    }
  }, []);

  useEffect(() => {
    fetchData('', '');
    fetchZonesAndChefs();

    // Nettoyage du timeout lors du démontage
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

 
const handleCreate = async (e) => {
      e.preventDefault();
      try {
        // Nettoyer les données avant envoi (convertir chaînes vides en null pour champs numériques)
        const cleanedClient = {
          ...newClient,
          commercial_id: newClient.commercial_id === '' ? null : parseInt(newClient.commercial_id),
          chef_zone_id: newClient.chef_zone_id === '' ? null : parseInt(newClient.chef_zone_id),
          merchandiser_id: newClient.merchandiser_id === '' ? null : parseInt(newClient.merchandiser_id),
          latitude: newClient.latitude === '' ? null : parseFloat(newClient.latitude),
          longitude: newClient.longitude === '' ? null : parseFloat(newClient.longitude),
          contact: newClient.contact || null,
          typologie: newClient.typologie || null,
          localisation: newClient.localisation || null,
          zone: newClient.zone || null,
          sous_zone: newClient.sous_zone || null,
          lieu_dit: newClient.lieu_dit || null
        };

        await axiosInstance.post('/admin/clients/', cleanedClient);
        alert('Client créé avec succès !');
        fetchData(searchTerm, filterZone);
        setNewClient({
          nom_client: '',
          contact: '',
          typologie: '',
          localisation: '',
          zone: '',
          sous_zone: '',
          commercial_id: '',
          chef_zone_id: '',
          merchandiser_id: '',
          lieu_dit: '',
          est_gms: false,
          latitude: null,
          longitude: null
        });
      } catch (error) {
        console.error('Erreur détaillée:', error.response?.data);
        alert('Erreur lors de la création.');
      }
    };





  const handleZoneChange = (zone) => {
    setNewClient({ ...newClient, zone });
    // Les merchandisers sont déjà chargés, pas besoin de recharger
  };
  
  const handleDelete = async (clientId) => {
    if (window.confirm(`Supprimer le client ID ${clientId} ?`)) {
      try {
        await axiosInstance.delete(`/admin/clients/${clientId}`);
        alert('Client supprimé !');
        fetchData(searchTerm, filterZone);
      } catch (error) { alert('Erreur de suppression.'); }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.put(`/admin/clients/${editingClient.id}`, editingClient);
      alert('Client mis à jour !');
      closeEditModal();
      fetchData(searchTerm);
    } catch (error) { alert('Erreur de mise à jour.'); }
  };

  const openEditModal = async (client) => {
    setEditingClient(JSON.parse(JSON.stringify(client)));
    setIsModalOpen(true);
    // Les commerciaux et merchandisers sont déjà chargés au montage
  };

  const closeEditModal = () => {
    setIsModalOpen(false);
    // On ne vide pas les listes ici car elles sont utilisées pour tout le formulaire
  };

  const nomsMerchandisers = useMemo(() => {
    const table = {};
    merchandisers.forEach(m => { table[m.id] = m.user?.nom || `Merchandiser #${m.id}`; });
    return table;
  }, [merchandisers]);

  // Un client dont le statut n'est pas 'valide' n'apparaît dans aucune liste côté
  // terrain : il faut le signaler, sinon une réaffectation semble sans effet.
  const STATUTS = {
    valide: { libelle: 'Actif', couleur: '#198754' },
    inactif: { libelle: 'Inactif — invisible sur le terrain', couleur: '#dc3545' },
    en_attente: { libelle: 'En attente de validation', couleur: '#fd7e14' },
  };

  const clientZones = useMemo(() => {
    const zoneSet = new Set(clients.map(c => c.zone).filter(Boolean));
    return Array.from(zoneSet).sort();
  }, [clients]);

  const filteredClients = useMemo(() => {
    return clients.filter(c => {
      if (filterBase) {
        const zone = (c.zone || '').toUpperCase();
        if (filterBase === 'YAOUNDE' && !zone.includes('YAOUNDE') && zone !== 'HORS YAOUNDE') return false;
        if (filterBase === 'DOUALA' && !zone.includes('DOUALA')) return false;
        if (filterBase === 'BAFOUSSAM' && !zone.startsWith('BAFOUSSAM') && !zone.startsWith('PERIPHERIQUE')) return false;
      }
      if (filterZone && c.zone !== filterZone) return false;
      if (filterMerchandiser && c.merchandiser_id !== parseInt(filterMerchandiser)) return false;
      return true;
    });
  }, [clients, filterBase, filterZone, filterMerchandiser]);

  if (isLoading) return <div>Chargement...</div>;

  return (
    <div className="management-page">
      <h1>Gestion des Clients</h1>
      
      <div className="management-form-container">
        <h3>Ajouter un client</h3>
        <form onSubmit={handleCreate} className="management-form">
          <input
            value={newClient.nom_client}
            onChange={e => setNewClient({...newClient, nom_client: e.target.value})}
            placeholder="Nom du client"
            required
          />
          <input
            value={newClient.contact}
            onChange={e => setNewClient({...newClient, contact: e.target.value})}
            placeholder="Contact"
          />
          <input
            value={newClient.typologie}
            onChange={e => setNewClient({...newClient, typologie: e.target.value})}
            placeholder="Typologie"
          />
          <input
            value={newClient.localisation}
            onChange={e => setNewClient({...newClient, localisation: e.target.value})}
            placeholder="Localisation"
          />

          <select
            value={newClient.zone}
            onChange={e => handleZoneChange(e.target.value)}
            required
          >
            <option value="">-- Sélectionner une zone --</option>
            {zones.map((z, idx) => (
              <option key={idx} value={z.zone}>{z.zone}</option>
            ))}
          </select>

          <input
            value={newClient.sous_zone}
            onChange={e => setNewClient({...newClient, sous_zone: e.target.value})}
            placeholder="Sous-zone (optionnel)"
          />

          <select
            value={newClient.commercial_id}
            onChange={e => setNewClient({...newClient, commercial_id: e.target.value})}
          >
            <option value="">-- Sélectionner un commercial --</option>
            {commerciaux && commerciaux.length > 0 ? commerciaux.map((com) => (
              <option key={com.id} value={com.id}>{com.nom}</option>
            )) : <option>Aucun commercial disponible</option>}
          </select>

          {/* Superviseur GMS - Affiché uniquement si client GMS */}
          {newClient.est_gms && (
            <select
              value={newClient.chef_zone_id}
              onChange={e => setNewClient({...newClient, chef_zone_id: e.target.value})}
              style={{backgroundColor: '#e3f2fd', border: '2px solid #2196F3'}}
            >
              <option value="">-- Sélectionner un Superviseur GMS --</option>
              {superviseursGMS && superviseursGMS.length > 0 ? superviseursGMS.map((sup) => (
                <option key={sup.id} value={sup.id}>
                  {sup.user?.nom || `Superviseur ID ${sup.id}`} {sup.zone ? `- Zone: ${sup.zone}` : ''}
                </option>
              )) : <option>Aucun superviseur GMS disponible</option>}
            </select>
          )}

          <select
            value={newClient.merchandiser_id}
            onChange={e => setNewClient({...newClient, merchandiser_id: e.target.value})}
          >
            <option value="">-- Sélectionner un merchandiser (optionnel) --</option>
            {merchandisers.map((merc) => (
              <option key={merc.id} value={merc.id}>{merc.user?.nom || `Merchandiser #${merc.id}`}</option>
            ))}
          </select>

          <input
            value={newClient.lieu_dit}
            onChange={e => setNewClient({...newClient, lieu_dit: e.target.value})}
            placeholder="Lieu-dit / Secteur"
          />

          <div className="gps-fields" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
            <input
              type="number"
              step="any"
              value={newClient.latitude}
              onChange={e => setNewClient({...newClient, latitude: e.target.value ? parseFloat(e.target.value) : ''})}
              placeholder="Latitude (ex: 4.0510)"
              style={{ flex: 1 }}
            />
            <input
              type="number"
              step="any"
              value={newClient.longitude}
              onChange={e => setNewClient({...newClient, longitude: e.target.value ? parseFloat(e.target.value) : ''})}
              placeholder="Longitude (ex: 9.7680)"
              style={{ flex: 1 }}
            />
          </div>
          <small style={{ color: '#666', fontSize: '12px' }}>
            📍 Coordonnées GPS (optionnel) - Trouvez-les sur Google Maps
          </small>

          <div className="checkbox-group">
            <label>
              <input
                type="checkbox"
                checked={newClient.est_gms}
                onChange={e => setNewClient({...newClient, est_gms: e.target.checked})}
              />
              <span className="checkbox-label">Client GMS (Grande/Moyenne Surface)</span>
            </label>
          </div>

          {/* Type de Client (Direct/Indirect/À prospecter) */}
          <div className="input-group" style={{ marginTop: '15px' }}>
            <label style={{ fontWeight: '600', marginBottom: '5px', display: 'block' }}>📋 Type de Client</label>
            <select
              value={newClient.type_client || 'DIRECT'}
              onChange={e => {
                const type = e.target.value;
                setNewClient({
                  ...newClient,
                  type_client: type,
                  client_direct_nom: type === 'INDIRECT' ? newClient.client_direct_nom : ''
                });
              }}
              style={{ padding: '10px', fontSize: '14px', width: '100%', marginBottom: '10px' }}
            >
              <option value="DIRECT">✅ DIRECT</option>
              <option value="INDIRECT">🔄 INDIRECT</option>
              <option value="A_PROSPECTER">🔍 À PROSPECTER</option>
            </select>
            <small style={{ color: '#666', fontSize: '11px', display: 'block' }}>
              {newClient.type_client === 'INDIRECT'
                ? 'Client passant par un intermédiaire'
                : newClient.type_client === 'A_PROSPECTER'
                ? 'Client pas encore signé, en cours de prospection'
                : 'Client en direct avec l\'entreprise'}
            </small>
          </div>

          {/* Nom du Client Direct - Affiché uniquement si client INDIRECT */}
          {newClient.type_client === 'INDIRECT' && (
            <div className="input-group" style={{ marginTop: '10px' }}>
              <label style={{ fontWeight: '600', marginBottom: '5px', display: 'block' }}>🏢 Nom du Client Direct</label>
              <input
                value={newClient.client_direct_nom}
                onChange={e => setNewClient({...newClient, client_direct_nom: e.target.value})}
                placeholder="Nom du client direct (ex: PHARMACIE CENTRALE)"
                style={{ padding: '10px', fontSize: '14px', width: '100%' }}
              />
              <small style={{ color: '#666', fontSize: '11px', display: 'block', marginTop: '5px' }}>
                Le nom du client direct qui fournit ce point de vente
              </small>
            </div>
          )}

          <button type="submit">Ajouter</button>
        </form>
      </div>

      <div className="management-table-container">
        <div className="table-header">
          <h3>Liste des Clients ({filteredClients.length}){!searchTerm && !filterZone && clients.length >= 300 ? <span style={{fontSize:'12px', color:'#888', fontWeight:'normal', marginLeft:'8px'}}>(300 premiers — filtrez par zone ou nom pour voir tous)</span> : null}</h3>
          <input
            type="text"
            placeholder="Rechercher par nom ou contact..."
            className="search-input"
            value={searchTerm}
            onChange={e => {
              const value = e.target.value;
              setSearchTerm(value);
              if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
              searchTimeoutRef.current = setTimeout(() => fetchData(value, filterZone, true), 500);
            }}
          />
          {isSearching && <span className="searching-indicator">Recherche...</span>}
          <div style={{display:'flex', gap:'10px', marginTop:'10px', flexWrap:'wrap', alignItems:'center'}}>
            <select value={filterBase} onChange={e => { setFilterBase(e.target.value); setFilterZone(''); }} style={{padding:'6px 10px', borderRadius:'4px', border:'1px solid #ccc'}}>
              <option value="">Toutes les bases</option>
              <option value="YAOUNDE">YAOUNDE</option>
              <option value="DOUALA">DOUALA</option>
              <option value="BAFOUSSAM">BAFOUSSAM</option>
            </select>
            <select value={filterZone} onChange={e => { setFilterZone(e.target.value); fetchData(searchTerm, e.target.value, true); }} style={{padding:'6px 10px', borderRadius:'4px', border:'1px solid #ccc'}}>
              <option value="">Toutes les zones</option>
              {clientZones
                .filter(z => {
                  if (!filterBase) return true;
                  const zu = z.toUpperCase();
                  if (filterBase === 'YAOUNDE') return zu.includes('YAOUNDE') || zu === 'HORS YAOUNDE';
                  if (filterBase === 'BAFOUSSAM') return zu.startsWith('BAFOUSSAM') || zu.startsWith('PERIPHERIQUE');
                  return zu.includes('DOUALA');
                })
                .map((z, idx) => <option key={idx} value={z}>{z}</option>)}
            </select>
            <select value={filterMerchandiser} onChange={e => setFilterMerchandiser(e.target.value)} style={{padding:'6px 10px', borderRadius:'4px', border:'1px solid #ccc'}}>
              <option value="">Tous les merchandisers</option>
              {merchandisers.map(m => <option key={m.id} value={m.id}>{m.user?.nom || `Merchandiser #${m.id}`}</option>)}
            </select>
            {(filterBase || filterZone || filterMerchandiser) && (
              <button onClick={() => { setFilterBase(''); setFilterZone(''); setFilterMerchandiser(''); fetchData(searchTerm, '', true); }} style={{padding:'6px 12px', borderRadius:'4px', border:'1px solid #ccc', cursor:'pointer', backgroundColor:'#f5f5f5'}}>
                Effacer filtres
              </button>
            )}
          </div>
        </div>
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nom</th>
              <th>Contact</th>
              <th>Typologie</th>
              <th>Type Surface</th>
              <th>Localisation</th>
              <th>Zone</th>
              <th>Commercial</th>
              <th>Merchandiser</th>
              <th>Lieu-dit</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredClients.map(c => (
              <tr key={c.id}>
                <td>{c.id}</td>
                <td>{c.nom_client}</td>
                <td>{c.contact}</td>
                <td>{c.typologie}</td>
                <td>
                  <span className={`badge ${c.est_gms ? 'badge-gms' : 'badge-petite'}`}>
                    {c.est_gms ? '🏢 GMS' : '🏪 Petite Surface'}
                  </span>
                </td>
                <td>{c.localisation}</td>
                <td>{c.zone || '-'}</td>
                <td>{c.commercial_nom || (c.commercial_id ? `Commercial #${c.commercial_id}` : '-')}</td>
                <td>{c.merchandiser_id ? (nomsMerchandisers[c.merchandiser_id] || `Merchandiser #${c.merchandiser_id}`) : '-'}</td>
                <td>{c.lieu_dit || '-'}</td>
                <td>
                  <span style={{ color: (STATUTS[c.statut_validation] || {}).couleur || '#6c757d', fontWeight: '600', fontSize: '12px' }}>
                    {(STATUTS[c.statut_validation] || {}).libelle || c.statut_validation || '-'}
                  </span>
                </td>
                <td className="actions-cell">
                  <button className="action-button view-button" onClick={() => openEditModal(c)}>Modifier</button>
                  <button className="action-button reject-button" onClick={() => handleDelete(c.id)}>Supprimer</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal isOpen={isModalOpen} onRequestClose={closeEditModal} className="modal" overlayClassName="overlay">
        {editingClient && (
          <form onSubmit={handleUpdate}>
            <h2>Modifier le Client : {editingClient.nom_client}</h2>

            {editingClient.statut_validation && editingClient.statut_validation !== 'valide' && (
              <div style={{ background: '#fff3cd', border: '1px solid #ffc107', borderRadius: '6px', padding: '12px', marginBottom: '15px' }}>
                <p style={{ margin: 0, fontWeight: '600', color: '#856404' }}>
                  {editingClient.statut_validation === 'inactif'
                    ? 'Ce client est désactivé.'
                    : "Ce client attend encore d'être validé."}
                </p>
                <p style={{ margin: '6px 0 10px', fontSize: '13px', color: '#856404' }}>
                  Tant qu'il reste dans cet état, il n'apparaît chez aucun merchandiser,
                  même après un changement d'affectation.
                </p>
                <button
                  type="button"
                  onClick={() => setEditingClient({ ...editingClient, statut_validation: 'valide' })}
                  style={{ padding: '7px 16px', background: '#198754', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: '600' }}>
                  Rendre ce client actif
                </button>
              </div>
            )}

            {editingClient.statut_validation === 'valide' && (
              <p style={{ margin: '0 0 15px', fontSize: '13px', color: '#198754', fontWeight: '600' }}>
                Client actif : visible chez le merchandiser assigné.
              </p>
            )}
            <div className="input-group">
              <label>Nom</label>
              <input
                value={editingClient.nom_client || ''}
                onChange={e => setEditingClient({...editingClient, nom_client: e.target.value})}
              />
            </div>
            <div className="input-group">
              <label>Contact</label>
              <input
                value={editingClient.contact || ''}
                onChange={e => setEditingClient({...editingClient, contact: e.target.value})}
              />
            </div>
            <div className="input-group">
              <label>Typologie</label>
              <input
                value={editingClient.typologie || ''}
                onChange={e => setEditingClient({...editingClient, typologie: e.target.value})}
              />
            </div>
            <div className="input-group">
              <label>Localisation</label>
              <input
                value={editingClient.localisation || ''}
                onChange={e => setEditingClient({...editingClient, localisation: e.target.value})}
              />
            </div>
            <div className="input-group">
              <label>Zone</label>
              <select
                value={editingClient.zone || ''}
                onChange={e => {
                  const zone = e.target.value;
                  setEditingClient({...editingClient, zone});
                  // Les merchandisers sont déjà chargés, pas besoin de recharger
                }}
              >
                <option value="">-- Sélectionner une zone --</option>
                {zones.map((z, idx) => (
                  <option key={idx} value={z.zone}>{z.zone}</option>
                ))}
              </select>
            </div>
            <div className="input-group">
              <label>Sous-zone (optionnel)</label>
              <input
                value={editingClient.sous_zone || ''}
                onChange={e => setEditingClient({...editingClient, sous_zone: e.target.value})}
                placeholder="Ex: Secteur A, Zone Nord"
              />
            </div>
            <div className="input-group">
              <label>Commercial</label>
              <select
                value={editingClient.commercial_id || ''}
                onChange={e => setEditingClient({...editingClient, commercial_id: parseInt(e.target.value)})}
              >
                <option value="">-- Sélectionner un commercial --</option>
                {commerciaux && commerciaux.length > 0 ? commerciaux.map((com) => (
                  <option key={com.id} value={com.id}>{com.nom}</option>
                )) : <option>Aucun commercial disponible</option>}
              </select>
            </div>

            {/* Superviseur GMS - Affiché uniquement si client GMS */}
            {editingClient.est_gms && (
              <div className="input-group">
                <label>Superviseur GMS</label>
                <select
                  value={editingClient.chef_zone_id || ''}
                  onChange={e => setEditingClient({...editingClient, chef_zone_id: e.target.value ? parseInt(e.target.value) : null})}
                  style={{backgroundColor: '#e3f2fd', border: '2px solid #2196F3'}}
                >
                  <option value="">-- Sélectionner un Superviseur GMS --</option>
                  {superviseursGMS && superviseursGMS.length > 0 ? superviseursGMS.map((sup) => (
                    <option key={sup.id} value={sup.id}>
                      {sup.user?.nom || `Superviseur ID ${sup.id}`} {sup.zone ? `- Zone: ${sup.zone}` : ''}
                    </option>
                  )) : <option>Aucun superviseur GMS disponible</option>}
                </select>
              </div>
            )}

            <div className="input-group">
              <label>Merchandiser</label>
              <select
                value={editingClient.merchandiser_id || ''}
                onChange={e => setEditingClient({...editingClient, merchandiser_id: e.target.value ? parseInt(e.target.value) : null})}
              >
                <option value="">-- Sélectionner un merchandiser (optionnel) --</option>
                {merchandisers.map((merc) => (
                  <option key={merc.id} value={merc.id}>{merc.user?.nom || `Merchandiser #${merc.id}`}</option>
                ))}
              </select>
            </div>
            <div className="input-group">
              <label>Lieu-dit</label>
              <input
                value={editingClient.lieu_dit || ''}
                onChange={e => setEditingClient({...editingClient, lieu_dit: e.target.value})}
              />
            </div>
            <div className="input-group">
              <label>📍 Coordonnées GPS</label>
              <div style={{ display: 'flex', gap: '10px' }}>
                <input
                  type="number"
                  step="any"
                  value={editingClient.latitude || ''}
                  onChange={e => setEditingClient({...editingClient, latitude: e.target.value ? parseFloat(e.target.value) : null})}
                  placeholder="Latitude (ex: 4.0510)"
                  style={{ flex: 1 }}
                />
                <input
                  type="number"
                  step="any"
                  value={editingClient.longitude || ''}
                  onChange={e => setEditingClient({...editingClient, longitude: e.target.value ? parseFloat(e.target.value) : null})}
                  placeholder="Longitude (ex: 9.7680)"
                  style={{ flex: 1 }}
                />
              </div>
              <small style={{ color: '#666', fontSize: '11px' }}>Trouvez les coordonnées sur Google Maps</small>
            </div>
            <div className="input-group checkbox-group">
              <label>
                <input
                  type="checkbox"
                  checked={editingClient.est_gms || false}
                  onChange={e => setEditingClient({...editingClient, est_gms: e.target.checked})}
                />
                <span className="checkbox-label">Client GMS (Grande/Moyenne Surface)</span>
              </label>
            </div>

            {/* Type de Client (Direct/Indirect/À prospecter) */}
            <div className="input-group">
              <label>📋 Type de Client</label>
              <select
                value={editingClient.type_client || 'DIRECT'}
                onChange={e => {
                  const type = e.target.value;
                  setEditingClient({
                    ...editingClient,
                    type_client: type,
                    client_direct_nom: type === 'INDIRECT' ? (editingClient.client_direct_nom || '') : ''
                  });
                }}
              >
                <option value="DIRECT">✅ DIRECT</option>
                <option value="INDIRECT">🔄 INDIRECT</option>
                <option value="A_PROSPECTER">🔍 À PROSPECTER</option>
              </select>
              <small style={{ color: '#666', fontSize: '11px' }}>
                {editingClient.type_client === 'INDIRECT'
                  ? 'Client passant par un intermédiaire'
                  : editingClient.type_client === 'A_PROSPECTER'
                  ? 'Client pas encore signé, en cours de prospection'
                  : 'Client en direct avec l\'entreprise'}
              </small>
            </div>

            {/* Nom du Client Direct - Affiché uniquement si client INDIRECT */}
            {editingClient.type_client === 'INDIRECT' && (
              <div className="input-group">
                <label>🏢 Nom du Client Direct</label>
                <input
                  value={editingClient.client_direct_nom || ''}
                  onChange={e => setEditingClient({...editingClient, client_direct_nom: e.target.value})}
                  placeholder="Nom du client direct (ex: PHARMACIE CENTRALE)"
                />
                <small style={{ color: '#666', fontSize: '11px' }}>
                  Le nom du client direct qui fournit ce point de vente
                </small>
              </div>
            )}

            <div className="modal-actions">
              <button type="button" onClick={closeEditModal} className="button-secondary">Annuler</button>
              <button type="submit" className="button-primary">Sauvegarder</button>
            </div>
          </form>
        )}
      </Modal>
    </div>
  );
}

export default ClientManagementPage;
